// SupportPal global namespace, we use App because the help widget uses SupportPal.
var App = (function () {

    'use strict';

    // Create a public methods object
    var modules = {};

    /**
     * Add a module or function to the namespace.
     *
     * @param  {String}   name The name of the module.
     * @param  {Object}   obj  The module object.
     */
    modules.extend = function (name, obj) {
        if (typeof modules[name] !== "undefined") {
            throw new Error("A module with name '" + name + "' already exists.");
        }

        modules[name] = obj;
    };

    // Return public methods object
    return modules;

})();
